jQuery(document).ready(function ($) {
	$('[count-down-date]').each(function () {
		var $element = $(this);
		var dateString = $element.attr('count-down-date');
		
		// Parse MM/DD/YYYY format
		var dateParts = dateString.split('/');
		var targetDate = new Date(
			parseInt(dateParts[2], 10), // year
			parseInt(dateParts[0], 10) - 1, // month (0-indexed)
			parseInt(dateParts[1], 10) // day
		);
		
		// Function to update countdown
		function updateCountdown() {
			var now = new Date();
			var timeDiff = targetDate - now;
			
			if (timeDiff <= 0) {
				$element.text('00 hrs : 00 mins : 00 secs');
				return;
			}
			
			// Calculate hours, minutes, and seconds
			var hours = Math.floor(timeDiff / (1000 * 60 * 60));
			var minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
			var seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);
			
			// Format with leading zeros
			var hoursStr = hours.toString().padStart(2, '0');
			var minutesStr = minutes.toString().padStart(2, '0');
			var secondsStr = seconds.toString().padStart(2, '0');
			
			// Update element text
			$element.text(hoursStr + ' hrs : ' + minutesStr + ' mins : ' + secondsStr + ' secs');
		}
		
		// Update immediately
		updateCountdown();
		
		// Update every second
		setInterval(updateCountdown, 1000);
	});

	//function that checks if the user has scrolled past a given point or element, returns true or false
	function hasScrolledPast(pixelHeight) {
		var scrollPosition = window.scrollY;
		return scrollPosition > pixelHeight;
	}

	function getElementPosition(element) {
		return element.first().offset().top + element.first().outerHeight();
	}

	$(window).on('scroll', function() {
		if (hasScrolledPast(46)){
			$('.alertBar').slideUp();
			$('body').addClass('alertBar--scrolled');
		}
		else{
			$('.alertBar').slideDown();
			$('body').removeClass('alertBar--scrolled');
		}

		if ($('.stickyBuy').length > 0){
			if (hasScrolledPast(getElementPosition($('.pdpMain__addToCartButton')))){
				$('.header').slideUp();
				$('.stickyBuy').slideDown();
			}
			else{
				$('.header').slideDown();
				$('.stickyBuy').slideUp();
			}
		}
		
	});

	$('.alertBar__link').each(function(){
		var cloneHtml = `<a href="${$(this).attr('href')}" class="header__mobileMenuLowerLink">${$(this).text()}</a>`;
		$('.header__mobileMenuLower').append(cloneHtml);
	});

	$('.header__mobileMenuButton').on('click', function(){
		if ($(this).hasClass('header__mobileMenuButton--active')){
			$('.header__mobileMenuButton').removeClass('header__mobileMenuButton--active');
			$('.header__mobileMenu').hide();
			$('html').removeClass('mobile-menu-open');
		}
		else{
			$('.header__mobileMenuButton').toggleClass('header__mobileMenuButton--active');
			$('.header__mobileMenu').show();
			$('html').addClass('mobile-menu-open');
		}
	});

	$('.header__mobileNavButton--productDropdown').on('click', function(){
		if ($(this).hasClass('header__mobileNavButton--active')){
			$(this).removeClass('header__mobileNavButton--active');
			$(this).find('.header__mobileNavDropdown').slideUp();
		}
		else{
			$('.header__mobileNavButton').removeClass('header__mobileNavButton--active');
			$('.header__mobileNavDropdown').slideUp();
			$(this).toggleClass('header__mobileNavButton--active');
			$(this).find('.header__mobileNavDropdown').slideDown();
		}
	});
});
